var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAutosync(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "#E45C2B",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 9.9C10.8 10.3972 10.397 10.8 9.9 10.8C9.40298 10.8 9 10.3972 9 9.9L9 9.18838C8.32866 9.93281 7.91997 10.9187 7.91997 12C7.91997 14.3197 9.80039 16.2 12.12 16.2C14.4396 16.2 16.32 14.3197 16.32 12C16.32 10.0562 14.9996 8.4208 13.2068 7.94209L13.8998 6.26836C16.3444 7.02656 18.12 9.30586 18.12 12C18.12 15.3138 15.4337 18 12.12 18C8.80627 18 6.11997 15.3138 6.11997 12C6.11997 10.3646 6.7741 8.88223 7.83501 7.8L6.9 7.8C6.40298 7.8 6 7.39717 6 6.9C6 6.40283 6.40298 6 6.9 6L10.8 6L10.8 9.9Z",
    fill: "#E45C2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAutosync);
export default __webpack_public_path__ + "static/media/icon-autosync.a65e93a0c170c6cce85b782429c37ace.svg";
export { ForwardRef as ReactComponent };